import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=4792c02a&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationPanel.vue?vue&type=style&index=0&id=4792c02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4792c02a",
  null
  
)

export default component.exports